<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>配件信息</span>
    </div>
    <div style="display:flex;font-size:14px;line-height:30px;color:#606266;margin-bottom:10px;">
      <div>多选操作：</div>
      <div style="display:flex;">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker
            :disabled= !selList.length
            v-model="batchDocDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="批量修改选中单据日期"
            @change="onDocDate">
          </el-date-picker>
        </div>
      </div>
      <div style="display:flex;">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker 
            :disabled= !selList.length
            v-model="batchEndTime" 
            value-format="yyyy-MM-dd" 
            format="yyyy-MM-dd" 
            type="date" 
            placeholder="批量修改选中预计完工日期"
            @change="onDocEndTime">
          </el-date-picker>
        </div>
      </div>
    </div>
    <el-table
      :data="Products"
      class="table_bottom table-line tb-c-head"
      border
      max-height="353"
      @row-click="rowClick"
      :row-class-name="tableRowClassName"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column type="index" label="序号" fixed="left"/>
      <el-table-column
        prop="OrderProductNo"
        label="布产单号"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="WorkDocNo"
        label="工单号"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="Pno"
        label="配件编码"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="Pname"
        label="配件名称"
        min-width="120"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="ProductSpec"
        label="规格"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="PdUnitName"
        label="单位"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="120">
        <template slot-scope="{ row }">
          <el-select
            v-if="Status === 0"
            v-model="row.ColorId"
            v-show="row.UseColor"
            @change="changeColor($event, row)"
          >
            <el-option
              v-for="item in row.Colors"
              :key="item.ColorId"
              :value="item.ColorId"
              :label="item.ColorName"
            ></el-option>
          </el-select>
          <span v-else>{{ row.ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="需求数量" min-width="120">
        <template slot-scope="{ row }">
          <el-input
            v-if="Status === 0"
            v-model="row.qua"
            @change="changePQuantity($event, row)"
          />
          <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="120">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)"
            >{{ row.ProductId ? "查看" : "" }}
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="Remarks"
        label="备注"
        min-width="120"
      ></el-table-column> -->
      <el-table-column
        prop="ProduceTypeName"
        label="存货类型"
        min-width="120"
      ></el-table-column>

      <el-table-column prop="StockQuantity" label="库存数量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="生产数量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{
            row.qua - (row.StockQuantity ?? 0) < 0
              ? 0
              : row.qua - (row.StockQuantity ?? 0)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="InQuantity" label="累计入库数" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.InQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="未入库数" min-width="120">
        <template slot-scope="{ row }">
          <span>{{
            row.qua && row.InQuantity
              ? row.qua - row.InQuantity > 0
                ? row.qua - row.InQuantity
                : 0
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PickingWarehouseId" label="预入仓" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-model="row.PickingWarehouseId">
            <el-option
              v-for="item in warehouseList"
              :key="item.WarehouseId"
              :label="item.WarehouseName"
              :value="item.WarehouseId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column
        key="column1"
        v-if="!QuickProcess"
        prop="SchedulingType"
        label="排产类型"
        min-width="120"
      >
        <template slot-scope="{ row }">
          <el-select
            v-if="Status === 0"
            v-model="row.SchedulingType"
            v-show="!QuickProcess"
            @change="changeSchedulingType($event, row)"
          >
            <el-option
              key="SchedulingType1"
              label="部门"
              :value="0"
            ></el-option>
            <el-option
              key="SchedulingType2"
              label="设备"
              :value="1"
            ></el-option>
          </el-select>
          <span v-else>{{ row.SchedulingType === 0 ? "部门" : "设备" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        key="column2"
        v-if="!QuickProcess"
        label="加工部门/设备"
        min-width="120"
      >
        <template slot-scope="{ row }">
          <dp-select
            v-if="row.SchedulingType === 0"
            style="width: 180px"
            :disabled="Status === 1"
            @input="editT(row)"
            v-model="row.DpId"
            v-show="!QuickProcess"
          />
          <el-select
            v-else
            style="width: 180px"
            @input="editT(row)"
            :disabled="Status === 1"
            v-model="row.MaintenanceId"
            v-show="!QuickProcess"
          >
            <el-option
              v-for="item in equipmentList"
              :key="item.EquipmentId"
              :label="item.EquipmentName"
              :value="item.EquipmentId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column> -->
      <el-table-column
        label="生产部门"
        min-width="120"
        key="column2"
      >
        <template slot-scope="{ row }">
          <dp-select
            v-show="row.ProductionType == 0"
            style="width: 180px"
            @input="editT(row)"
            :disabled="Status === 1"
            v-model="row.DpId"
          />
        </template>
      </el-table-column>
      <el-table-column prop="ProductionType" label="生产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select
            v-model="row.ProductionType"
            @change="editT(row)"
            v-if="Status === 0"
          >
            <el-option
              v-if="
                row.currentProductNature === 2 || row.currentProductNature === 0
              "
              key="ProductionType1"
              label="自产"
              :value="0"
            ></el-option>
            <el-option
              v-if="
                row.currentProductNature === 2 || row.currentProductNature === 1
              "
              key="ProductionType2"
              label="委外"
              :value="1"
            ></el-option>
          </el-select>
          <span v-else>{{ row.ProductionType === 0 ? "自产" : "委外" }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="ProductionDpId" label="加工商" min-width="120">
        <template slot-scope="{ row }">
          <!-- <dp-select
            v-if="row.ProductionType !== 1"
            style="width: 180px"
            @input="editT(row)"
            :disabled="Status === 1"
            v-model="row.ProductionDpId"
          /> -->
          <el-select
            v-model="row.ProductionDpId"
            @change="editT(row)"
            v-if="row.ProductionType === 1"
            :disabled="row.ProductionType === 1 && Status !== 0"
            filterable
          >
            <el-option
              v-for="item in tradeUnitList"
              :key="item.TradeUnitId"
              :label="item.FullName"
              :value="item.TradeUnitId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="DocDate" label="单据日期" min-width="120">
        <template slot-scope="{ row }">
          <el-date-picker
            v-if="Status === 0"
            v-model="row.DocDate"
            @change="editT(row)"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <span v-else>{{ row.DocDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="EndTime" label="预计完工日期" min-width="160">
        <template slot-scope="{ row }">
          <el-date-picker
            v-if="Status === 0"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="row.EndTime"
            @change="editT(row)"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <span v-else>{{ row.EndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="工单备注" min-width="120">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Remark"
            type="text"
            @change="editT(row)"
            v-if="Status === 0"
          ></el-input>
          <span v-else>{{ row.Remark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Bomno"
        label="BOM版本号"
        min-width="120"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="delPro(row, $index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-tabs v-model="activeName" type="card" v-show="isShowTabs">
      <el-tab-pane label="工艺" name="1">
        <div v-for="(item, index) in itemProcessModels" :key="index">
          <div class="flex1">
            <div class="flex2">
              <div class="mr8">{{ item.ProgrammeName }}</div>
              <el-button type="primary" @click="changeProgramme(item)"
                >选择方案</el-button
              >
            </div>
          </div>

          <el-table
            :data="item.Processes"
            class="table_bottom table-line tb-c-head"
            border
            ref="list3"
          >
            <el-table-column prop="ProcessId" label="工序名称" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessId">
                  <el-option
                    v-for="(item, index) in teProcessList"
                    :key="index"
                    :value="item.ProcessId"
                    :label="item.ProcessName"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="ProductionType"
              label="自制工序或者委外工序"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <el-select
                  v-model="row.ProcessType"
                  @change="changeProcessType(row)"
                  :disabled="disabled"
                >
                  <el-option key="a1" label="自制工序" :value="0"></el-option>
                  <el-option key="a2" label="委外工序" :value="1"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="TradeUnitId"
              label="委外供应商"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <div class="flex" v-show="row.ProcessType === 1">
                  <span v-if="disabled">{{ row.TradeUnitName }}</span>
                  <el-input
                    v-else
                    type="text"
                    v-model="row.TradeUnitName"
                    readonly
                  />
                  <el-button
                    v-if="!disabled"
                    type="primary"
                    @click="selectCome(row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="产品子件" name="2">
        <div class="flex1" v-if="Status === 0">
          <div>{{ isShowTabs ? itemDetailModels[0].Pname : "" }}</div>
          <el-button type="primary" v-show="isShowTabs" @click="add"
            >添加</el-button
          >
        </div>
        <div v-for="(item, index) in itemDetailModels" :key="index">
          <el-table
            :data="item.DetailModels"
            class="table_bottom table-line tb-c-head"
            border
          >
            <el-table-column
              prop="Pno"
              label="子件编码"
              min-width="120"
            ></el-table-column>
            <el-table-column prop="Pname" label="子件名称" min-width="120">
              <template slot-scope="{ row, $index }">
                <account-select
                  v-if="Status === 0"
                  v-model="row.Pname"
                  :source="DAccount"
                  @select="onSelect($event, row, $index)"
                  :pageSize="pageParams.pageSize"
                  :pageIndex="pageParams.pageIndex"
                  :listTotal="listTotal"
                  @inputText="inputText"
                  @click.native="resetFun"
                  @currentPage="currentPage"
                  :pageType="true"
                />
                <span v-else>{{ row.Pname }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="ProductSpec"
              label="规格"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="PdUnitName"
              label="单位"
              min-width="120"
            ></el-table-column>
            <el-table-column prop="PropertyName" label="属性" min-width="120">
              <template slot-scope="{ row }">
                <el-select
                  v-if="Status === 0"
                  v-model="row.PropertyId"
                  v-show="row.UseProcess"
                  @change="changeProperty($event, row)"
                >
                  <el-option
                    v-for="item in propertyList"
                    :key="item.PropertyId"
                    :value="item.PropertyId"
                    :label="item.PropertyName"
                  ></el-option>
                </el-select>
                <span v-else>{{ row.PropertyName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ColorName" label="颜色" min-width="120">
              <template slot-scope="{ row }">
                <el-select
                  v-if="Status === 0"
                  v-model="row.ColorId"
                  v-show="row.UseColor"
                  @change="changeColor($event, row)"
                >
                  <el-option
                    v-for="item in row.Colors"
                    :key="item.ColorId"
                    :value="item.ColorId"
                    :label="item.ColorName"
                  ></el-option>
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Quantity" label="需求数量" min-width="120">
              <template slot-scope="{ row }">
                <el-input
                  v-if="Status === 0"
                  clearable
                  v-model="row.qua"
                  @change="changeQua($event, row, item)"
                  placeholder="请输入数量"
                  type="number"
                />
                <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="ImgUrl" label="图片" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)"
                  >{{ row.ProductId ? "查看" : "" }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="Remarks" label="备注" min-width="120">
              <template slot-scope="{ row }">
                <el-input
                  v-if="Status === 0"
                  clearable
                  v-model="row.Remarks"
                  @change="changeRemarks($event, row)"
                  placeholder="请输入备注"
                  type="text"
                />
                <span v-else>{{ row.Remarks }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="注塑bom版本号"
              prop="MouldBomNo"
              align="center"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <!-- <span  >{{row.BomNo}}</span> -->
                <child-select
                  v-show="row.MouldId != null && row.ProduceTypeName === '胶件' && row.PropertyName === '注塑'"
                  v-model="row.MouldBomNo"
                  :source="row.MouldBomNos"
                  :Head="[{ Value: 'MouldNo', Name: '模具编码', Width: '150' },
                      { Value: 'MouldName', Name: '模具名称', Width: '120' },   
                      { Value: 'Bomno', Name: '版本号', Width: '120' }]" 
                  @select="onSelectMouldBomNo($event, row)"
                  :pageType="false"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="ProduceTypeName"
              label="存货类型"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="StockQuantity"
              label="库存数量"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="ExistQuantity"
              label="可用量"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <span>{{  $commonJs.toThousands(row.ExistQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="PickingQuantity"
              label="已领用数量"
              min-width="120"
            >
            <template slot-scope="{ row }">
              <span>{{  $commonJs.toThousands(row.PickingQuantity) }}</span>
            </template>
            </el-table-column>
            <el-table-column
              prop="ConsumeQuantity"
              label="已耗用数量"
              min-width="120"
            >
            <template slot-scope="{ row }">
              <span>{{  $commonJs.toThousands(row.ConsumeQuantity) }}</span>
            </template>
            </el-table-column>

            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="80"
            >
              <template slot-scope="{ $index }">
                <el-button type="text" @click="del(item, $index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- <div class="row-tb-head" style="margin-top: 10px">
      <span>工艺</span>
    </div> -->

    <!-- <div class="row-tb-head" style="margin-top: 10px">
      <span>配件子件</span>
    </div> -->

    <come-list-dialog
      @select="comeSelect"
      selectable
      :multiple="false"
      ref="comeListDialog"
      in-dialog
    />
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog
      ref="listDialog"
      selectable
      :multiple="false"
      @select="listDialogSelect"
    ></list-dialog>
  </div>
</template>
<script>
import accountSelect from "../select";
import comeListDialog from "@/components/basedata/business/come/listDialog";
import detailDialog from "./detailDialog";
import { urlHttp } from "./bomConfig";
import imgDialog from "./imgDialog";
import dpSelect from "./dpSelect";
import vSelect from "./vSelect";
import listDialog from "@/components/production/craftsmanship/solutions/fittings/listDialog";
import childSelect from "@/components/business/stock/childSelect";


export default {
  components: {
    accountSelect,
    comeListDialog,
    detailDialog,
    imgDialog,
    dpSelect,
    vSelect,
    listDialog,
    childSelect,
  },
  data() {
    return {
      sumData: [],
      tableData: [],
      sumTableData: [],
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      pdApi: require("@/api/ba/product").default,
      teMouldBomApi: require("@/api/production/teMouldBom").default,
      propertyList: [],
      tradeUnitList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      currentRow: null,
      programmeCurrentRow: null,
      DetailModels: [],
      Products: [],
      ProcessModels: [],
      imgs: [],
      deleteProducts: [],
      deleteProcessModels: [],
      deleteDetailModels: [],
      deleteLineDetailModels: [],
      equipmentList: [],
      activeName: "2",

      teProcessApi: require("@/api/production/teProcess").default,
      teProcessList: [],
      disabled: false,
      itemProcessModels: [],
      itemDetailModels: [],
      isShowTabs: false,
      currentIndex: -1,
      deleteProcess: [],
      warehouseList: [],
      selList:'',//选中行的列表
      batchDocDate: null, //批量单据日期
      batchEndTime:null,//预计完工日期
    };
  },
  props: {
    Status: {
      type: Number,
      default: 0,
    },
    QuickProcess: {
      type: Boolean,
      default: false,
    },
    scQuantity: {
      type: Number,
      default: 1,
    },
    PartsBoms: {
      type: Object,
      default: () => {},
    },
    editParts: {
      type: Array,
      default: () => [],
    },
    OrderProductNo: {
      type: String,
      default: "",
    },
    productLists: {
      type: Array,
      default: () => [],
    },
    propertyListProp: {
      type: Array,
      default: () => [],
    },
    editType: {
      type: Number,
      default: 0,
    },
    tradeUnitListProp: {
      type: Array,
      default: () => [],
    },
    equipmentListProp: {
      type: Array,
      default: () => [],
    },
    warehouseProp: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    propertyListProp(val) {
      this.propertyList = val;
    },
    scQuantity(val) {
      this.DetailModels.forEach((item) => {
        item.DetailModels.forEach((item) => {
          if (item.qua) {
            if (this.editType === 1 && item.T !== 0) {
              item.T = 1;
            }
            item.qua = Math.ceil(item.Quantity * val);
          }
        });
      });

      this.Products.forEach((item) => {
        if (item.qua) {
          if (this.editType === 1 && item.T !== 0) {
            item.T = 1;
          }
          item.qua = Math.ceil(item.Quantity * val);
        }
      });
    },
    PartsBoms(val) {
      let { Bom, DetailModels, ProcessModels } = val;

      Bom.forEach((item) => {
        item.currentProductNature = item.ProductNature;
        if (item.ProductNature === 2) {
          item.ProductNature = 0;
        }
        this.$set(item, "T", 0);
        this.$set(item, "WorkDocId", 0);
        this.$set(item, "WorkDocProductId", 0);
        this.$set(item, "WorkDocNo", "");
        this.$set(item, "StockQuantity", item.StockQuantity);
        this.$set(item, "ExistQuantity", item.ExistQuantity);
        this.$set(item, "SchedulingType", null);
        this.$set(item, "DpId", null);
        this.$set(item, "MaintenanceId", null);
        this.$set(item, "ProductionType", item.ProductNature);
        this.$set(item, "ProductionDpId", item.DefaultSupplier);
        this.$set(item, "DocDate", this.$commonJs.getToday());
        this.$set(item, "EndTime", this.$commonJs.getToday());
        this.$set(item, "Remark", "");
        this.$set(item, "Pno", item.ProductNo);
        this.$set(item, "Pname", item.ProductName);
        this.$set(item, "PickingWarehouseId", null);
      });

      this.Products = Bom;

      this.Products.forEach((item) => {
        this.$set(item, "qua", item.Quantity * this.scQuantity);
      });

      DetailModels.forEach((item, i) => {
        item.DetailModels.forEach((v) => {
          v.T = 0;
          v.WorkDocMaterialId = 0;
          v.WorkDocId = 0;
          v.Ration = 0;
          v.RationUnit = 0;
          v.Rate = 0;
          v.Loss = 0;
          v.Remarks = "";
          v.rateQua = item.fqua / v.Quantity;
          this.$set(v, "qua", v.Quantity * this.scQuantity);
          v.lastProductId = v.ProductId;
          v.currentProductId = v.ProductId;
          v.Pno = v.ProductNo;
          v.Pname = v.ProductName;
          v.lastProcessStage = v.ProcessStage;
          v.currentProcessStage = v.ProcessStage;
          v.lastPropertyId = v.PropertyId;
          v.currentPropertyId = v.PropertyId;
          v.OrderProductNo = this.Products[0].OrderProductNo;

          if(v.MouldId != null & v.PropertyName === '注塑' && v.ProduceTypeName === '胶件'){
            this.teMouldBomApi.list({
              IsEnable: true,
              MouldId: v.MouldId,
            }).then(res => {
              if(res.Code === 0){
                v.MouldBomNos = res.Data;
              }
            })
          }
        });
      });

      this.DetailModels = DetailModels;

      ProcessModels.forEach((item) => {
        item.T = 0;
        item.WorkDocProcessId = 0;
        item.WorkDocId = 0;
        item.SnType = 0;
        item.ConvertRatio = 1;
        item.MachineId = 0;
        item.Length = 0;
        item.Width = 0;
        item.Multiple = 0;
        item.RatedLoss = 0;
        item.LossRate = 0;
        item.PlanIn = 0;
        (item.PlanOut = 0), (item.PlanOutUnit = "");
        item.Requirement = "";
        item.Status = 0;
      });

      this.ProcessModels = ProcessModels;

      // let arr = [];
      // let _DetailModels = [];
      // let _ProcessModels = [];
      // val.forEach(item => {
      //   let {DetailModels, ProcessModels, ...rest} = item;
      //   let Pname = rest.Pname;
      //   let Pno = rest.Pno;
      //   let ProductId = rest.ProductId;

      //   DetailModels.forEach(item => {
      //       item.T = 0;
      //       item.WorkDocMaterialId = 0;
      //       item.WorkDocId = 0;
      //       item.Ration = 0;
      //       item.RationUnit = 0;
      //       item.Rate = 0;
      //       item.Loss = 0;
      //       item.rateQua = rest.Quantity / item.Quantity;
      //       this.$set(item, 'qua', item.Quantity * this.scQuantity)
      //       item.lastProductId = item.ProductId;
      //       item.currentProductId = item.ProductId;
      //   })

      //   let child = DetailModels;
      //   let o = {
      //     Pname,
      //     ProductId,
      //     DetailModels: child
      //   }
      //   _DetailModels.push(o)
      //   arr.push(rest)

      //   let copyProcessModels = JSON.parse(JSON.stringify(ProcessModels))

      //    copyProcessModels.forEach(item => {
      //         item.T = 0;
      //         item.WorkDocProcessId = 0;
      //         item.WorkDocId = 0;
      //         item.SnType = 0;
      //         item.ConvertRatio = 1;
      //         item.MachineId = 0;
      //         item.Length = 0;
      //         item.Width = 0;
      //         item.Multiple = 0;
      //         item.RatedLoss = 0;
      //         item.LossRate = 0;
      //         item.PlanIn = 0;
      //         item.PlanOut = 0,
      //         item.PlanOutUnit = "";
      //         item.Requirement = "";
      //         item.Status = 0;
      //     })

      //   let processO = {
      //     Pno,
      //     Pname,
      //     ProductId,
      //     ProgrammeName: ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeName : "",
      //     ProgrammeId: ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeId : 0,
      //     Processes: copyProcessModels
      //   }
      //   _ProcessModels.push(processO)
      // })

      // this.DetailModels = _DetailModels;
      // this.ProcessModels = _ProcessModels;

      // console.log('=======this.ProcessModels=========', this.ProcessModels)

      //  arr.forEach(item => {
      //     this.$set(item, 'T', 0);
      //     this.$set(item, 'WorkDocId', 0);
      //     this.$set(item, 'WorkDocProductId', 0);
      //     this.$set(item, 'WorkDocNo', "");
      //     this.$set(item, 'StockQuantity', 0);
      //     this.$set(item, 'SchedulingType', null);
      //     this.$set(item, 'DpId', null);
      //     this.$set(item, 'MaintenanceId', null);
      //     this.$set(item, 'ProductionType', item.ProductNature);
      //     this.$set(item, 'ProductionDpId', item.DefaultSupplier);
      //     this.$set(item, 'DocDate', this.$commonJs.getToday());
      //     this.$set(item, 'EndTime', this.$commonJs.getToday());
      //     this.$set(item, 'Remark', "");

      //   })

      // arr.forEach(item => {
      //   this.$set(item, 'qua', item.Quantity * this.scQuantity);
      // })

      // this.Products = arr
    },
    editParts(val) {
      let _ProductModels = [];
      let _ProcessModels = [];
      let _MaterialModels = [];

      console.log("配件工单触发更新", val);

      val.forEach((item) => {
        let { MaterialModels, ProcessModels, ProductModels, ...rest } = item;

        MaterialModels.forEach((item) => {

          item.currentProductId = item.ProductId;
          item.lastProcessStage = item.ProcessStage;
          item.currentProcessStage = item.ProcessStage;
          item.lastPropertyId = item.PropertyId;
          item.currentPropertyId = item.PropertyId;

          item.PdUnitName = item.UnitName;
          item.PdUnitId = item.QuantityUnit;
          item.Pname = item.ProductName;
          item.Pno = item.ProductNo;
          item.ChildBomNo =
            item.ChildGroupNo !== "" && item.ChildGroupNo != null
              ? item.ChildGroupNo
              : item.ChildBomNo;
          this.$set(item, "qua", item.Quantity * this.scQuantity);

          if(item.MouldId != null & item.PropertyName === '注塑' && item.ProduceTypeName === '胶件'){
            this.teMouldBomApi.list({
              IsEnable: true,
              MouldId: item.MouldId,
            }).then(res => {
              if(res.Code === 0){
                item.MouldBomNos = res.Data;
              }
            })
          }
        });

        ProductModels.forEach((item) => {
          item.OrderProductNo = this.OrderProductNo;
          item.Bomno =
            item.ChildGroupNo !== "" && item.ChildGroupNo != null
              ? item.ChildGroupNo
              : item.Bomno;
          item.Pname = item.ProductName;
          item.Pno = item.ProductNo;

          item.currentProductNature = item.ProductNature;

          for (let i in rest) {
            if (!item.hasOwnProperty(i)) {
              this.$set(item, i, rest[i]);
            }
          }

          let o1 = {
            pid: item.ProductId,
            Pname: item.ProductName,
            fqua: item.Quantity,
            DetailModels: MaterialModels,
          };

          _MaterialModels.push(o1);

          let o = {
            Pname: item.ProductName,
            Pno: item.ProductNo,
            pid: item.ProductId,
            ProgrammeName: ProcessModels[0]?.ProgrammeName ?? "",
            Processes: ProcessModels,
          };

          _ProcessModels.push(o);
        });

        _ProductModels.push(...ProductModels);
      });

      _ProductModels.forEach((item) => {
        this.$set(item, "qua", item.Quantity * this.scQuantity);
      });

      _MaterialModels.forEach((item) => {
        item.DetailModels.forEach((v) => {
          v.rateQua = item.fqua / v.Quantity;
        });
      });

      this.changeT(_ProductModels);
      this.changeT(_ProcessModels, 2);
      this.changeT(_MaterialModels, 1);

      this.Products = _ProductModels;
      this.ProcessModels = _ProcessModels;
      this.DetailModels = _MaterialModels;
    },
    // productLists(val){
    //    let data = val.filter(item => {
    //       return item.ProcessStage !== 3 && item.ProcessStage !== 4
    //     })
    //     this.DAccount = data;
    //     this.initDAccount = data;
    //     this.listTotal = data.length;
    //     this.initTotal = data.length;
    // },
    tradeUnitListProp(val) {
      this.tradeUnitList = val;
    },
    equipmentListProp(val) {
      this.equipmentList = val;
    },
    warehouseProp(val) {
      this.warehouseList = val;
    },
  },
  created() {
    this.teProcessApi.list({}).then((res) => {
      if (res.Code === 0) {
        this.teProcessList = res.Data;

        console.log("====this.teProcessList ====", this.teProcessList);
      }
    });
    this.pdApi
      .list({
        ProcessStages: [2],
        Status: 1,
        pageSize: this.pageParams.pageSize,
        pageIndex: this.pageParams.pageIndex,
      })
      .then((res) => {
        if (res.Code === 0) {
          console.log("productApi res.Data", res.Data);
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        }
      });
    // this.tradeUnitApi.list({ TradeUnitTypes: [1, 3], Status: 1 }).then((res) => {
    //   if (res.Code === 0) {
    //     this.tradeUnitList = res.Data;
    //   }
    // });
  },
  methods: {
    changeProperty(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1;
      }
      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
      row.PropertyId = item.PropertyId;

      if(item.PropertyName !== '注塑'){
        row.MouldBomNo = "";
        if(row.add == null){
          row.add = true;
        }
        if(row.isAddList == null){
          row.isAddList = false;
        }
        if(!row.ChildBomNo){
          row.ChildBomNo = Date.now() + Math.random() * 5 + "-";
        }
        this.changeList(row);
        row.isAddList = true;
      }
      

      
    },
    changeColor(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1;
        console.log("row", row);
      }
      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;

      this.$message.info('颜色更改, bom版本可能不一致, 如有需要请手动更改')

      this.changeList(row);
    },
    onSelectMouldBomNo(e, row){
      row.MouldBomNo = e.Bomno;
      if(row.T !== 0){
        row.T = 1;
      }

      this.changeList(row);
      row.isAddList = true;
    },
    changeList(
      row,
      dataProductId = 0,
      lastProcessStage = -1,
      lastPropertyId = 0
    ) {
      this.$emit(
        "changeList",
        row,
        dataProductId,
        lastProcessStage,
        lastPropertyId
      );
    },
    changeProcessType(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    jsonCopy(data) {
      return JSON.parse(JSON.stringify(data));
    },
    changePQuantity(val, row) {
      let { index } = row;
      let detailModels = this.DetailModels[index].DetailModels;
      console.log("detailModels", detailModels);

      if (row.T !== 0) {
        row.T = 1;
      }
      if (detailModels.length !== 0) {
        detailModels.forEach((item) => {
          if (item.T !== 0) {
            item.T = 1;
          }
          item.qua = val / item.rateQua;
        });

        this.$emit("ChangeListParts", this.jsonCopy(detailModels));
      }
    },

    // 表格行点击，根据存货，显示对应的数据到工艺和产品子件
    rowClick(row) {
      let { index } = row;
      console.log("index", index);

      this.currentIndex = index;

      let _itemProcessModels = [];
      let _itemDetailModels = [];

      _itemProcessModels.push(this.ProcessModels[index]);
      _itemDetailModels.push(this.DetailModels[index]);

      this.itemProcessModels = _itemProcessModels;
      this.itemDetailModels = _itemDetailModels;

      console.log("this.itemProcessModels", this.itemProcessModels);
      console.log("this.itemDetailModels", this.itemDetailModels);

      this.isShowTabs = true;
    },
    delPro(row, i) {
      this.$confirm("确定删除这条记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        let { index } = row;

        if (row.T !== 0) {
          let delProduct = this.Products[index];
          delProduct.T = 2;
          this.deleteProducts.push(delProduct);
        }

        console.log("this.DetailModels", this.DetailModels);

        let detailBom = this.DetailModels.filter((item) => {
          return item.pid === row.ProductId;
        })[0];

        detailBom.DetailModels.forEach((item) => {
          item.delete = true;
          if (item.T !== 0) {
            item.T = 2;
            this.deleteDetailModels.push(detailBom);
          }
        });
        console.log("this.deleteDetailModels", this.deleteDetailModels);

        let dindex = this.DetailModels.findIndex((item) => {
          return item.pid === detailBom.pid;
        });

        let dindex1 = this.ProcessModels.findIndex((item) => {
          return item.pid === row.ProductId;
        });
        let ProcessModelsObj = this.ProcessModels[dindex1];
        if (ProcessModelsObj.T !== 0) {
          ProcessModelsObj.T = 2;
          this.deleteProcessModels.push(ProcessModelsObj);
        }

        this.Products.splice(index, 1);
        this.DetailModels.splice(dindex, 1);
        this.ProcessModels.splice(dindex1, 1);

        this.isShowTabs = false;
      });
    },
    setList(data, dataProductId = 0) {
      if (this.Products.length !== 0) {
        if (data.delete) {
          // 查找对应父件的index，进行删除
          let index = this.Products.findIndex((item) => {
            return data.ChildBomNo === item.Bomno;
          });
          if (index === -1) {
            return;
          }
          let id = this.Products[index].ProductId;

          if (dataProductId !== 0) {
            id = dataProductId;
          }

          if (this.Products[index].T !== 0) {
            let delProduct = this.Products[index];
            delProduct.T = 2;
            this.deleteProducts.push(delProduct);
          }

          this.Products.splice(index, 1);
          console.log("this.DetailModels", this.DetailModels);

          let detailBom = this.DetailModels.filter((item) => {
            return item.pid === id;
          })[0];

          detailBom.DetailModels.forEach((item) => {
            item.delete = true;
            if (item.T !== 0) {
              item.T = 2;
              this.deleteDetailModels.push(detailBom);
            }
          });

          let dindex = this.DetailModels.findIndex((item) => {
            return item.pid === detailBom.pid;
          });

          let dindex1 = this.ProcessModels.findIndex((item) => {
            return item.pid === id;
          });
          let ProcessModelsObj = this.ProcessModels[dindex1];
          if (ProcessModelsObj.T !== 0) {
            ProcessModelsObj.T = 2;
            this.deleteProcessModels.push(ProcessModelsObj);
          }

          // this.$emit('ChangeListArray', detailBom.DetailModels)

          this.DetailModels.splice(dindex, 1);
          this.ProcessModels.splice(dindex1, 1);
        } else if (data.add && data.delete == null) {
          if (!data.isAddList) {
            data.Bomno = data.ChildBomNo;

            this.$set(data, "T", 0);
            this.$set(data, "WorkDocId", 0);
            this.$set(data, "WorkDocProductId", 0);
            this.$set(data, "WorkDocNo", "");
            this.$set(data, "StockQuantity", 0);
            this.$set(data, "ExistQuantity", 0);
            this.$set(data, "SchedulingType", null);
            this.$set(data, "DpId", null);
            this.$set(data, "MaintenanceId", null);
            this.$set(data, "ProductionType", data.ProductNature);
            this.$set(data, "ProductionDpId", data.DefaultSupplier);
            this.$set(data, "DocDate", this.$commonJs.getToday());
            this.$set(data, "EndTime", this.$commonJs.getToday());
            this.$set(data, "Remark", "");
            this.$set(data, "Pno", data.ProductNo);
            this.$set(data, "Pname", data.ProductName);
            this.$set(item, "PickingWarehouseId", null);
            this.Products.push(data);

            let o = {
              Pname: data.ProductName,
              pid: data.ProductId,
              fqua: data.Quantity,
              DetailModels: [],
            };
            this.DetailModels.push(o);

            let o1 = {
              T: 0,
              WorkDocProcessId: 0,
              WorkDocId: 0,
              SnType: 0,
              ConvertRatio: 1,
              MachineId: 0,
              Length: 0,
              Width: 0,
              Multiple: 0,
              RatedLoss: 0,
              LossRate: 0,
              PlanIn: 0,
              PlanOut: 0,
              PlanOutUnit: "",
              Requirement: "",
              Status: 0,
              Pname: data.ProductName,
              Pno: data.ProductNo,
              pid: data.ProductId,
              Processes: [],
            };
            this.ProcessModels.push(o1);
          } else {
            let { ChildBomNo } = data;
            let bom1 = this.Products.filter((item) => {
              return item.Bomno === ChildBomNo;
            });
            if (bom1.length === 0) {
              return;
            }
            let bom = bom1[0];

            bom.Pname = data.ProductName;
            bom.Pno = data.ProductNo;
            bom.ProductSpec = data.ProductSpec;
            bom.ProcessStage = data.ProcessStage;
            bom.ProduceTypeName = data.ProduceTypeName;
            bom.ProductId = data.ProductId;
            bom.Colors = data.Colors;
            bom.PdUnitName = data.PdUnitName;
            bom.PdUnitId = data.PdUnitId;
            bom.UseProcess = data.UseProcess;
            bom.UseColor = data.UseColor;
            bom.Mould = data.Mould;
            bom.MouldId = data.MouldId;
            bom.MouldName = data.MouldName;
            bom.DefaultSupplier = data.DefaultSupplier;
            bom.ProductNature = data.ProductNature;

            bom.ColorId = data.ColorId;
            bom.ColorName = data.ColorName;
            bom.qua = data.qua;

            bom.StockQuantity = data.StockQuantity;
            bom.ExistQuantity = data.ExistQuantity;

            // 找出父件对应的子件
            let childBom = this.DetailModels.filter((item) => {
              return item.pid === bom.ProductId;
            });

            if (childBom.length !== 0) {
              childBom[0].DetailModels.forEach((item) => {
                item.qua = bom.qua / item.rateQua;
              });
            }
          }
        } else {
          let { ChildBomNo } = data;
          let bom1 = this.Products.filter((item) => {
            console.log("item", item);
            return item.Bomno === ChildBomNo;
          });
          if (bom1.length === 0) {
            return;
          }
          let bom = bom1[0];
          console.log("触发配件 执行", data);
          console.log("触发配件 执行 bom", bom);

          bom.Pname = data.ProductName;
          bom.Pno = data.ProductNo;
          bom.ProductSpec = data.ProductSpec;
          bom.ProcessStage = data.ProcessStage;
          bom.ProduceTypeName = data.ProduceTypeName;
          bom.ProductId = data.ProductId;
          bom.Colors = data.Colors;
          bom.PdUnitName = data.PdUnitName;
          bom.PdUnitId = data.PdUnitId;
          bom.UseProcess = data.UseProcess;
          bom.UseColor = data.UseColor;
          bom.T = data.T;

          bom.Mould = data.Mould;
          bom.MouldId = data.MouldId;
          bom.MouldName = data.MouldName;

          bom.DefaultSupplier = data.DefaultSupplier;
          bom.ProductNature = data.ProductNature;

          bom.ColorId = data.ColorId;
          bom.ColorName = data.ColorName;
          bom.qua = data.qua;
          bom.StockQuantity = data.StockQuantity;
          bom.ExistQuantity = data.ExistQuantity;

          // 找出父件对应的子件
          let childBom = this.DetailModels.filter((item) => {
            return item.pid === bom.ProductId;
          })[0];

          childBom.DetailModels.forEach((item) => {
            item.qua = bom.qua / item.rateQua;
            item.T = data.T;
          });
          console.log("childBom", childBom);
        }
      }

      this.isShowTabs = false;
    },
    sumRubbers(data) {
      let arr = [];
      let copyData = JSON.parse(JSON.stringify(data));
      copyData.forEach((item) => {
        let length = arr.length;
        // console.log("length", length);
        let bool = true;
        for (let i = 0; i < length; ++i) {
          // console.log("item", item);
          // console.log("arr", arr);
          if (
            item.ProductId === arr[i].ProductId &&
            item.ColorId === arr[i].ColorId
          ) {
            arr[i].Quantity = arr[i].Quantity + item.Quantity;
            console.log(`arr[${i}].Quantity`, arr[i].Quantity);
            arr[i].qua = arr[i].qua + item.qua;
            console.log(`arr[${i}].qua`, arr[i].qua);
            bool = false;
            break;
          }
        }
        if (bool) {
          arr.push(item);
          // console.log("arr", arr);
        }
      });

      console.log("sumRubbers arr", arr);

      return arr;
    },
    changeT(data, type = 0) {
      if (type === 0) {
        data.forEach((item) => {
          item.T = null;
        });
      } else if (type === 1) {
        data.forEach((item) => {
          item.DetailModels.forEach((v) => {
            v.T = null;
          });
        });
      } else if (type === 2) {
        data.forEach((item) => {
          item.T = null;
          item.Processes.forEach((v) => {
            v.T = 1;
          });
        });
      }
    },
    editT(row) {
      // if(this.editType === 1 && row.T !== 0){
      //   row.T = 1;
      // }
    },
    selectCome(row) {
      if (row.TradeUnitName == null) {
        this.$set(row, "TradeUnitName", "");
      }
      this.currentRow = row;
      this.$refs.comeListDialog.open().then((that) => {
        that.getData({ TradeUnitType: 3 });
      });
    },
    // delProcess(){

    // },
    listDialogSelect(list) {
      let deleteProcessModels = JSON.parse(
        JSON.stringify(this.programmeCurrentRow)
      );
      if (
        deleteProcessModels.Processes.length !== 0 &&
        deleteProcessModels.Processes[0].T === 1
      ) {
        deleteProcessModels.Processes.forEach((item) => {
          item.T = 2;
        });

        this.deleteProcess.push(...deleteProcessModels.Processes);

        console.log("this.deleteProcess", this.deleteProcess);
      }

      list.Processes.forEach((item) => {
        item.ProcessType = null;
        item.DpId = 0;
        item.TradeUnitName = "";
      });

      this.programmeCurrentRow.Processes = list.Processes;
      this.programmeCurrentRow.ProgrammeId = list.ProgrammeId;
      this.programmeCurrentRow.ProgrammeName = list.ProgrammeName;

      let item = this.Products.filter((item) => {
        return item.ProductId === this.programmeCurrentRow.pid;
      })[0];
      item.ProgrammeId = list.ProgrammeId;
      if (item.T !== 0) {
        item.T = 1;
      }
      let copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels));
      this.ProcessModels = [];
      this.$nextTick(() => {
        this.ProcessModels = copyProcessModels;
        let arr = [];
        arr.push(this.ProcessModels[this.currentIndex]);
        this.itemProcessModels = arr;
      });
    },
    detail_saved(list) {
      this.programmeCurrentRow.Processes = list;
    },
    changeProgramme(row) {
      this.programmeCurrentRow = row;
      this.$refs.listDialog.open();
    },
    changeProgrammeInfo(row) {
      this.programmeCurrentRow = row;
      this.$refs.detailDialog.open().then((that) => {
        that.setTableData(row);
      });
    },
    changeRemarks(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1;
      }
    },
    changeQua(val, row, item) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1;
      }
      val = parseFloat(val);

      if (!row.Quantity) {
        row.Quantity = val / this.scQuantity;
      }
      if (!row.rateQua) {
        let pid = item.pid;
        let obj = this.Products.filter((v) => {
          return v.ProductId === pid;
        })[0];
        row.rateQua = obj.Quantity / row.Quantity;
      }

      row.qua = val;

      this.changeList(row);
    },
    onSelect(e, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1;
      }
      row.MouldBomNo = "";
      row.lastProductId = row.currentProductId;
      row.currentProductId = e.ProductId;

      row.lastProcessStage = row.currentProcessStage;
      row.currentProcessStage = e.ProcessStage;

      row.ColorId = 0;
      row.PropertyId = 0;
      this.$set(row, "Pname", e.ProductName);
      this.$set(row, "Pno", e.ProductNo);
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;

      row.ProductSpec = e.ProductSpec;
      row.ProcessStage = e.ProcessStage;
      row.ProduceTypeName = e.ProduceTypeName;
      row.ProductId = e.ProductId;
      row.Colors = e.Colors;
      row.PdUnitName = e.PdUnitName;
      row.PdUnitId = e.PdUnitId;
      row.UseProcess = e.UseProcess;
      row.UseColor = e.UseColor;

      row.Mould = e.Mould;
      row.MouldId = e.MouldId;
      row.MouldName = e.MouldName;

      row.DefaultSupplier = e.DefaultSupplier;
      row.ProductNature = e.ProductNature;
      row.StockQuantity = e.StockQuantity;
      row.ExistQuantity = e.ExistQuantity;

      if( row.MouldId != null && row.ProduceTypeName === '胶件'){
        this.teMouldBomApi.list({
          IsEnable: true,
          MouldId: e.MouldId,
        }).then(res => {
          if(res.Code === 0){
            row.MouldBomNos = res.Data;
          }
        })
      }

      if (row.isAddList && (row.ProcessStage === 0 || row.ProcessStage === 2)) {
        row.delete = true;
        console.log("删除");
        this.changeList(
          row,
          row.lastProductId,
          row.lastProcessStage,
          row.lastPropertyId
        );
      } else if (row.isAddList === false && (row.ProcessStage === 0 || row.ProcessStage === 2)) {
        //
      } else if (row.add == null && (row.ProcessStage === 0 || row.ProcessStage === 2)) {
        row.delete = true;
        this.changeList(
          row,
          row.lastProductId,
          row.lastProcessStage,
          row.lastPropertyId
        );
      } else {
        this.changeList(row);
      }

      if (row.ProcessStage !== 1 && row.ProcessStage !== 2) {
        row.isAddList = true;
      }
      if(row.ProcessStage === 0 || row.ProcessStage === 2){
        row.isAddList = false;
      }

    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({
          pageIndex: val,
          pageSize: 7,
          ProcessStages: [2],
          Status: 1,
          ProductName: text1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.pdApi
        .list({
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          ProcessStages: [2],
          Status: 1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    _getData(params) {
      this.getData(params);
    },
    tabChange(e) {
      if (e.index === "1") {
        this.sumTableData = [];
        let arr = [];
        this.DetailModels.forEach((item) => {
          arr.push(...item.DetailModels);
        });
        this.sumTableData = this.sumRubbers(arr);
      }
    },
    add() {
      
      let o = {
        T: 0,
        WorkDocId: 0,
        WorkDocNo: "",
        WorkDocMaterialId: 0,
        Pno: "",
        Pname: "",
        ProductId: 0,
        ImgUrl: "",
        ProductSpec: "",
        PdUnitId: 0,
        PdUnitName: "",
        ColorId: 0,
        ColorName: "",
        Quantity: "",
        ProcessStage: "",
        ProduceTypeName: "",
        StockQuantity: "",
        ExistQuantity: "",
        PickingQuantity: "",
        ConsumeQuantity: "",
        PropertyId: 0,
        PropertyName: "",
        Loss: 0,
        Rate: 0,
        Ration: 0,
        RationUnit: 0,
        Remarks: "",
        qua: 0,
        MouldBomNo: "",
        MouldBomNos: [],
        add: true,
        isAddList: false, // 是否被添加到下个阶段的父件列表
        ChildBomNo: Date.now() + Math.random() * 5 + "-",
        OrderProductNo: this.Products[0].OrderProductNo,
      };
      this.DetailModels[this.currentIndex].DetailModels.push(o);
    },
    // changeProgrammeName(val){
    //   this.ProcessModels[this.currentIndex].ProgrammeId = 0;
    //   this.ProcessModels[this.currentIndex].Processes.forEach(item => {
    //     item.ProgrammeId = 0;
    //     item.ProgrammeName = val
    //   })
    // },
    // addProcesses(){

    //   if(this.ProcessModels[this.currentIndex].ProgrammeId !== 0){
    //     this.$message.error('请先修改方案名称')
    //     return
    //   }

    //   let o = {
    //     BomType: 0,
    //     DpId: 0,
    //     ProcessId: null,
    //     ProcessName: "",
    //     ProcessType: null,
    //     ProgrammeId: 0,
    //     ProgrammeName: this.ProcessModels[this.currentIndex].ProgrammeName,
    //     T: 0,
    //     TeProductId: 0,
    //     TeProductProcessId: 0,
    //     TebomId: 0,
    //     TespecialBomId: 0,
    //     TradeUnitName: null,
    //     WorkDocId: 0,
    //     WorkDocProcessId: 0,
    //   }
    //   this.ProcessModels[this.currentIndex].Processes.push(o)

    // },
    comeSelect(row) {
      this.currentRow.DpId = row.TradeUnitId;
      this.currentRow.TradeUnitName = row.FullName;
      if (this.currentRow.T !== 0) {
        this.currentRow.T = 1;
      }
    },
    changeSchedulingType(val, row) {
      this.editT(row);
      if (val === 0) {
        row.DpId = 0;
      } else if (val === 1) {
        row.MaintenanceId = 0;
      }
    },
    del(item, index) {
      this.$confirm("确定删除这条记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        row.delete = true;
        if (this.editType === 1 && row.T !== 0) {
          let o = {
            pid: item.pid,
            deleteRow: row,
          };
          this.deleteLineDetailModels.push(o);
        }
        item.DetailModels.splice(index, 1);
        this.changeList(row);
      });
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(Imgs) {
    //   let imgUrls = Imgs.map((item) => item.ImgUrl);

    //   this.imgs = imgUrls;
    //   this.$refs.imgDialog.open();
    // },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }

      return {
        start,
        end,
      };
    },
    filterData(data) {
      return data.filter((item) => {
        return item.T != null;
      });
    },
    sendData() {
      // 检查必填项目
      let keys = []; // 必填的字段
      // SchedulingType DpId MaintenanceId ProductionType  ProductionDpId
      this.Products.forEach((item) => {
        if (!this.QuickProcess && item.SchedulingType == null) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: "排产类型",
          });
        } else if (
          item.SchedulingType === 0 &&
          (item.DpId == null || item.DpId == 0) &&
          !this.QuickProcess
        ) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: "部门",
          });
        } else if (
          item.SchedulingType === 1 &&
          (item.MaintenanceId == null || item.MaintenanceId == 0) &&
          !this.QuickProcess
        ) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: "设备",
          });
        }
        if (item.ProductionType !== 0 && item.ProductionDpId == null) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: "供应商",
          });
        }

        // if(item.PickingWarehouseId == null){
        //   keys.push({
        //     name: item.ProductName,
        //     id: item.ProductId,
        //     key: "领料仓库",
        //   });
        // }
      });

      if (keys.length !== 0) {
        // 构造提示信息
        let arr = Array.from(
          new Set(
            keys.map((item) => {
              return item.id;
            })
          )
        );

        let msgArr2d = [];
        arr.forEach((item) => {
          msgArr2d.push(
            keys.filter((v) => {
              return v.id === item;
            })
          );
        });

        let msgArr = [];
        msgArr2d.forEach((item) => {
          let name = item[0].name;
          let keyStr = item
            .map((v) => {
              return v.key;
            })
            .join(",");
          msgArr.push(`请填写配件工单存货${name}一列中的${keyStr}`);
        });

        let msg = msgArr.join("<br/>");
        this.$message({
          type: "warning",
          message: msg,
          dangerouslyUseHTMLString: true,
        });

        return false;
      }

      let length = this.Products.length;
      let arr = [];

      for (let i = 0; i < length; ++i) {
        let ProductModels = [];
        let ProcessModels = [];
        let MaterialModels = [];

        // 对默认值进行设置
        let o = {
          T: this.Products[i].T,
          WorkDocProductId: this.Products[i].WorkDocProductId,
          WorkDocId: this.Products[i].WorkDocId,
          ProductId: this.Products[i].ProductId,
          PdUnitId: this.Products[i].PdUnitId,
          ProgrammeId: this.ProcessModels[i]?.ProgrammeId ?? 0,
          ColorId: this.Products[i].ColorId,
          Quantity: this.Products[i].qua,
          TeProductId: this.Products[i].TeProductId ?? 0,
          StockQuantity: this.Products[i].StockQuantity,
          ExistQuantity: this.Products[i].ExistQuantity,
          SourceDtsId: 0,
          RpType: this.Products[i].ProcessStage,
          RpRequirement: this.Products[i].RpRequirement ?? "",
          SnType: this.Products[i].SnType ?? 0,
          Loss: this.Products[i].Loss ?? 0,
          Status: this.Products[i].Status ?? 0,
          OrderNo: this.Products[i].OrderProductNo,
          WorkDocNo: this.Products[i].WorkDocNo,
          ChildGroupNo: this.Products[i].add
            ? this.Products[i].Bomno
            : this.Products[i].ChildGroupNo
            ? this.Products[i].ChildGroupNo
            : "",
        };

        ProductModels.push(o);

        console.log("ProductModels", ProductModels);

        this.ProcessModels[i]?.Processes.forEach((item) => {
          let o = {
            T: item.T,
            ProgrammeId: item.ProgrammeId,
            ProcessType: item.ProcessType,
            DpId: item.DpId ?? 0,
            WorkDocProcessId: item.WorkDocProcessId ?? 0,
            WorkDocId: this.Products[i].WorkDocId ?? 0,
            ProcessId: item.ProcessId,
            ProcessSn: item.ProcessSn,
            SnType: item.SnType ?? 0,
            ConvertRatio: item.ConvertRatio ?? 1,
            MachineId: item.MachineId ?? 0,
            Length: item.Length ?? 0,
            Width: item.Width ?? 0,
            Multiple: item.Multiple ?? 0,
            RatedLoss: item.RatedLoss ?? 0,
            LossRate: item.LossRate ?? 0,
            PlanIn: item.PlanIn ?? 0,
            PlanOut: item.PlanOut ?? 0,
            PlanOutUnit: item.PlanOutUnit ?? "",
            Requirement: item.Requirement ?? "",
            Status: item.Status ?? 0,
          };
          ProcessModels.push(o);
        });

        let _Processes = this.deleteProcess.filter((item) => {
          return item.WorkDocId === this.Products[i].WorkDocId;
        });

        _Processes.forEach((item) => {
          let o = {
            T: 2,
            ProgrammeId: item.ProgrammeId,
            ProcessType: item.ProcessType,
            DpId: item.DpId ?? 0,
            WorkDocProcessId: item.WorkDocProcessId ?? 0,
            WorkDocId: item.WorkDocId ?? 0,
            ProcessId: item.ProcessId,
            ProcessSn: item.ProcessSn,
            SnType: item.SnType ?? 0,
            ConvertRatio: item.ConvertRatio ?? 1,
            MachineId: item.MachineId ?? 0,
            Length: item.Length ?? 0,
            Width: item.Width ?? 0,
            Multiple: item.Multiple ?? 0,
            RatedLoss: item.RatedLoss ?? 0,
            LossRate: item.LossRate ?? 0,
            PlanIn: item.PlanIn ?? 0,
            PlanOut: item.PlanOut ?? 0,
            PlanOutUnit: item.PlanOutUnit ?? "",
            Requirement: item.Requirement ?? "",
            Status: item.Status ?? 0,
          };
          ProcessModels.push(o);
        });

        console.log("ProcessModels", ProcessModels);

        this.DetailModels[i]?.DetailModels.forEach((item) => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: this.Products[i].WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.qua,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            Remarks: item.Remarks,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            MouldBomNo: item.MouldBomNo,
            ChildGroupNo: item.add
              ? item.ChildBomNo
              : item.ChildGroupNo
              ? item.ChildGroupNo
              : "",
          };
          MaterialModels.push(o);
        });
        console.log("MaterialModels", MaterialModels);

        let {
          WorkDocId,
          WorkDocNo = "",
          SchedulingType = 0,
          DpId = 0,
          MaintenanceId = 0,
          ProductionType,
          ProductionDpId = 0,
          DocDate,
          EndTime,
          Remark = "",
          qua,
          StockQuantity,
          ExistQuantity,
          StartTime,
          PickingWarehouseId = PickingWarehouseId ?? 0,
        } = this.Products[i];
        if (DpId == null) {
          DpId = 0;
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0;
        }
        let { start } = this.cycleChange("今天");
        if (StartTime) {
          start = StartTime;
        }
        SchedulingType = SchedulingType ?? 0;
        DpId = DpId ?? 0;
        MaintenanceId = MaintenanceId ?? 0;
        ProductionDpId = ProductionDpId ?? 0;
        let Quantity = qua - StockQuantity > 0 ? qua - StockQuantity : qua;

        let data = {
          Stage: 2,
          WorkDocType: 0,
          ProductType: 0,
          StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          Quantity,
          PickingWarehouseId: PickingWarehouseId ?? 0,
        };

        ProductModels = this.filterData(ProductModels);
        ProcessModels = this.filterData(ProcessModels);
        let _MaterialModels_ = this.deleteLineDetailModels.filter((item) => {
          return item.pid === this.Products[i].ProductId;
        });
        let _MaterialModels = _MaterialModels_.map((item) => {
          return item.deleteRow;
        });
        MaterialModels = MaterialModels.concat(_MaterialModels);
        MaterialModels = this.filterData(MaterialModels);

        let o1 = {
          ProductModels,
          ProcessModels,
          MaterialModels,
          ...data,
        };

        arr.push(o1);
      }

      // 需要删除的
      length = this.deleteProducts.length;
      for (let i = 0; i < length; ++i) {
        let ProductModels = [];
        let ProcessModels = [];
        let MaterialModels = [];

        // 对默认值进行设置
        let o = {
          T: this.deleteProducts[i].T,
          WorkDocProductId: this.deleteProducts[i].WorkDocProductId,
          WorkDocId: this.deleteProducts[i].WorkDocId,
          ProductId: this.deleteProducts[i].ProductId,
          PdUnitId: this.deleteProducts[i].PdUnitId,
          ProgrammeId: this.deleteProcessModels[i]?.ProgrammeId ?? 0,
          ColorId: this.deleteProducts[i].ColorId,
          Quantity: this.deleteProducts[i].qua,
          TeProductId: this.deleteProducts[i].TeProductId ?? 0,
          StockQuantity: this.deleteProducts[i].StockQuantity,
          ExistQuantity: this.deleteProducts[i].ExistQuantity,
          SourceDtsId: 0,
          RpType: this.deleteProducts[i].ProcessStage,
          RpRequirement: this.deleteProducts[i].RpRequirement ?? "",
          SnType: this.deleteProducts[i].SnType ?? 0,
          Loss: this.deleteProducts[i].Loss ?? 0,
          Status: this.deleteProducts[i].Status ?? 0,
          OrderNo: this.deleteProducts[i].OrderProductNo,
          WorkDocNo: this.deleteProducts[i].WorkDocNo,
          ChildGroupNo: this.Products[i]?.add ? this.Products[i]?.Bomno : "",
        };

        ProductModels.push(o);

        console.log("ProductModels", ProductModels);

        this.deleteProcessModels[i]?.Processes.forEach((item) => {
          let o = {
            T: item.T,
            ProgrammeId: item.ProgrammeId,
            ProcessType: item.ProcessType,
            DpId: item.DpId ?? 0,
            WorkDocProcessId: item.WorkDocProcessId ?? 0,
            WorkDocId: this.deleteProducts[i].WorkDocId ?? 0,
            ProcessId: item.ProcessId,
            ProcessSn: item.ProcessSn,
            SnType: item.SnType ?? 0,
            ConvertRatio: item.ConvertRatio ?? 1,
            MachineId: item.MachineId ?? 0,
            Length: item.Length ?? 0,
            Width: item.Width ?? 0,
            Multiple: item.Multiple ?? 0,
            RatedLoss: item.RatedLoss ?? 0,
            LossRate: item.LossRate ?? 0,
            PlanIn: item.PlanIn ?? 0,
            PlanOut: item.PlanOut ?? 0,
            PlanOutUnit: item.PlanOutUnit ?? "",
            Requirement: item.Requirement ?? "",
            Status: item.Status ?? 0,
          };
          ProcessModels.push(o);
        });

        console.log("ProcessModels", ProcessModels);

        this.deleteDetailModels[i]?.DetailModels.forEach((item) => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: this.deleteProducts[i].WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.qua,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            Remarks: item.Remarks,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            ChildGroupNo: item.add ? item.ChildBomNo : "",
            MouldBomNo: item.MouldBomNo,
          };
          MaterialModels.push(o);
        });
        console.log("MaterialModels", MaterialModels);

        let {
          WorkDocId,
          WorkDocNo = "",
          SchedulingType = 0,
          DpId = 0,
          MaintenanceId = 0,
          ProductionType,
          ProductionDpId = 0,
          DocDate,
          EndTime,
          Remark = "",
          qua,
          StockQuantity,
          ExistQuantity,
          StartTime,
          PickingWarehouseId = PickingWarehouseId ?? 0,
        } = this.deleteProducts[i];
        if (DpId == null) {
          DpId = 0;
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0;
        }
        let { start } = this.cycleChange("今天");
        if (StartTime) {
          start = StartTime;
        }
        SchedulingType = SchedulingType ?? 0;
        DpId = DpId ?? 0;
        MaintenanceId = MaintenanceId ?? 0;
        ProductionDpId = ProductionDpId ?? 0;
        let Quantity = qua - StockQuantity > 0 ? qua - StockQuantity : qua;

        let data = {
          Stage: 3,
          WorkDocType: 0,
          ProductType: 0,
          StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          Quantity,
          PickingWarehouseId: PickingWarehouseId ?? 0,
        };

        ProductModels = this.filterData(ProductModels);
        ProcessModels = this.filterData(ProcessModels);
        let _MaterialModels_ = this.deleteLineDetailModels.filter((item) => {
          return item.pid === this.Products[i].ProductId;
        });
        let _MaterialModels = _MaterialModels_.map((item) => {
          return item.deleteRow;
        });
        MaterialModels = MaterialModels.concat(_MaterialModels);
        MaterialModels = this.filterData(MaterialModels);

        let o1 = {
          ProductModels,
          ProcessModels,
          MaterialModels,
          ...data,
        };

        arr.push(o1);
      }

      return arr;

      // let arr = [];
      // let length =  this.Products.length;

      // for(let i = 0; i < length; ++i){
      //   let ProductModels = [];
      //   let ProcessModels = [];
      //   let MaterialModels = [];
      //   let o1 = {
      //     T: this.Products[i].T,
      //     WorkDocProductId: this.Products[i].WorkDocProductId || 0,
      //     WorkDocId: this.Products[i].WorkDocId,
      //     ProductId: this.Products[i].ProductId,
      //     PdUnitId: this.Products[i].PdUnitId,
      //     TebomId: this.Products[i].TebomId	,
      //     ProgrammeId: this.Products[i].ProgrammeId,
      //     ColorId: this.Products[i].ColorId	,
      //     Quantity: this.Products[i].qua,
      //     StockQuantity: this.Products[i].StockQuantity  || 0,
      //     SourceDtsId: 0,
      //     RpType: this.Products[i].ProcessStage,
      //     RpRequirement: "",
      //     SnType: 0,
      //     Loss: 0,
      //     Status: 0,
      //     OrderNo: this.Products[i].OrderProductNo,
      //     WorkDocNo: this.Products[i].WorkDocNo  || "",
      //   };

      //   let {WorkDocId, WorkDocNo = "", SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,EndTime,Remark = ""} = this.Products[i];
      //   if(DpId == null){
      //     DpId = 0
      //   }
      //   if(MaintenanceId == null){
      //     MaintenanceId = 0
      //   }
      //   SchedulingType = SchedulingType ?? 0;
      //   DpId = DpId ?? 0;
      //   MaintenanceId = MaintenanceId ?? 0;
      //   ProductionDpId = ProductionDpId ?? 0;
      //   let {start} = this.cycleChange('今天')
      //   let data = {
      //     Stage: 2,
      //     WorkDocType: 0,
      //     ProductType: 0,
      //     StartTime: start,
      //     WorkDocId, WorkDocNo,
      //     EndTime,
      //     SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,Remark
      //   }
      //   ProductModels.push(o1)

      //   this.ProcessModels[i].Processes.forEach(item => {
      //   let o2 = {
      //     T: item.T,
      //     ProgrammeId: item.ProgrammeId,
      //     ProcessType: item.ProcessType,
      //     DpId: item.DpId,
      //     WorkDocProcessId: item.WorkDocProcessId,
      //     WorkDocId:item.WorkDocId,
      //     ProcessId:item.ProcessId,
      //     ProcessSn:item.ProcessSn,
      //     SnType:item.SnType,
      //     ConvertRatio:item.ConvertRatio,
      //     MachineId:item.MachineId,
      //     Length:item.Length,
      //     Width:item.Width,
      //     Multiple:	item.Multiple,
      //     RatedLoss:item.RatedLoss,
      //     LossRate:	item.LossRate,
      //     PlanIn:	item.PlanIn,
      //     PlanOut:	item.PlanOut,
      //     PlanOutUnit:item.PlanOutUnit,
      //     Requirement:item.Requirement,
      //     Status:item.Status,
      //   }
      //   ProcessModels.push(o2)

      // })

      // this.DetailModels[i].DetailModels.forEach(item => {
      //   let o3 = {
      //     T: item.T,
      //     WorkDocMaterialId: item.WorkDocMaterialId,
      //     WorkDocId: item.WorkDocId,
      //     ProductId: item.ProductId,
      //     ColorId: item.ColorId,
      //     Ration: item.Ration,
      //     RationUnit: item.RationUnit,
      //     Quantity: item.qua,
      //     QuantityUnit: item.PdUnitId,
      //     PropertyId: item.Property,
      //     Rate: item.Rate,
      //     Loss: item.Loss,
      //   }
      //   MaterialModels.push(o3)

      // })

      // ProductModels = this.filterData(ProductModels)
      // ProcessModels = this.filterData(ProcessModels)
      // MaterialModels = MaterialModels.concat(this.deleteLineDetailModels)
      // MaterialModels = this.filterData(MaterialModels)

      //   let obj = {
      //     ProductModels,
      //     ProcessModels,
      //     MaterialModels,
      //     ...data
      //   }

      //   arr.push(obj)
      // }

      // // 删除
      // let deleteProductsLength =  this.deleteProducts.length;

      // for(let i = 0; i < deleteProductsLength; ++i){
      //   let ProductModels = [];
      //   let ProcessModels = [];
      //   let MaterialModels = [];
      //   let o1 = {
      //     T: this.deleteProducts[i].T,
      //     WorkDocProductId: this.deleteProducts[i].WorkDocProductId || 0,
      //     WorkDocId: this.deleteProducts[i].WorkDocId,
      //     ProductId: this.deleteProducts[i].ProductId	,
      //     PdUnitId: this.deleteProducts[i].PdUnitId,
      //     TebomId: this.deleteProducts[i].TebomId	,
      //     ProgrammeId: this.Products[i].ProgrammeId,
      //     ColorId: this.deleteProducts[i].ColorId	,
      //     Quantity: this.deleteProducts[i].qua,
      //     StockQuantity: this.deleteProducts[i].StockQuantity || 0,
      //     SourceDtsId: 0,
      //     RpType: this.deleteProducts[i].ProcessStage,
      //     RpRequirement: "",
      //     SnType: 0,
      //     Loss: 0,
      //     Status: 0,
      //     OrderNo: this.deleteProducts[i].OrderProductNo,
      //     WorkDocNo: this.deleteProducts[i].WorkDocNo || "",
      //   };

      //   let {
      //     WorkDocId, WorkDocNo = "", SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,EndTime,Remark = ""} = this.deleteProducts[i];
      //   if(DpId == null){
      //     DpId = 0
      //   }
      //   if(MaintenanceId == null){
      //     MaintenanceId = 0
      //   }
      //   SchedulingType = SchedulingType ?? 0;
      //   DpId = DpId ?? 0;
      //   MaintenanceId = MaintenanceId ?? 0;
      //   ProductionDpId = ProductionDpId ?? 0;
      //   let {start} = this.cycleChange('今天')
      //   let data = {
      //     Stage: 3,
      //     WorkDocType: 0,
      //     ProductType: 0,
      //     StartTime: start,
      //     WorkDocId, WorkDocNo,
      //     EndTime,
      //     SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,Remark
      //   }
      //   ProductModels.push(o1)

      //   this.deleteProcessModels[i].Processes.forEach(item => {
      //   let o2 = {
      //     T: item.T,
      //     ProgrammeId: item.ProgrammeId,
      //     ProcessType: item.ProcessType,
      //     DpId: item.DpId,
      //     WorkDocProcessId: item.WorkDocProcessId,
      //     WorkDocId:item.WorkDocId,
      //     ProcessId:item.ProcessId,
      //     ProcessSn:item.ProcessSn,
      //     SnType:item.SnType,
      //     ConvertRatio:item.ConvertRatio,
      //     MachineId:item.MachineId,
      //     Length:item.Length,
      //     Width:item.Width,
      //     Multiple:	item.Multiple,
      //     RatedLoss:item.RatedLoss,
      //     LossRate:	item.LossRate,
      //     PlanIn:	item.PlanIn,
      //     PlanOut:	item.PlanOut,
      //     PlanOutUnit:item.PlanOutUnit,
      //     Requirement:item.Requirement,
      //     Status:item.Status,
      //   }
      //   ProcessModels.push(o2)

      // })

      // this.deleteDetailModels.forEach(item => {
      //   let o3 = {
      //     T: item.T,
      //     WorkDocMaterialId: item.WorkDocMaterialId,
      //     WorkDocId: item.WorkDocId,
      //     ProductId: item.ProductId,
      //     ColorId: item.ColorId,
      //     Ration: item.Ration,
      //     RationUnit: item.RationUnit,
      //     Quantity: item.qua,
      //     QuantityUnit: item.PdUnitId,
      //     PropertyId: item.Property,
      //     Rate: item.Rate,
      //     Loss: item.Loss,
      //   }
      //   MaterialModels.push(o3)

      // })

      // ProductModels = this.filterData(ProductModels)
      // ProcessModels = this.filterData(ProcessModels)
      // MaterialModels = this.filterData(MaterialModels)

      //   let obj = {
      //     ProductModels,
      //     ProcessModels,
      //     MaterialModels,
      //     ...data
      //   }

      //   arr.push(obj)
      // }

      // return arr;
    },
    setDetailModels(data) {
      data = JSON.parse(JSON.stringify(data));
      let ids = this.Products.map((item) => {
        return item.ProductId;
      });

      let ProcessModelsNames = this.ProcessModels.map((item) => {
        return item.ProductId;
      });

      let DetailModelsName = this.DetailModels.map((item) => {
        return item.ProductId;
      });

      let _ProcessModels = [];
      let _DetailModels = [];

      this.deleteProducts = [];
      this.deleteProcessModels = [];
      this.deleteDetailModels = [];

      // 先删除
      data.forEach((item, i) => {
        if (item.delete) {
          let pname = item.Pname;
          let productId = item.ProductId;

          let DetailModelsIndex = this.DetailModels.findIndex((item) => {
            return pname === item.Pname;
          });

          let ProcessModelsIndex = this.ProcessModels.findIndex((item) => {
            return pname === item.Pname;
          });

          let index = data.findIndex((item) => {
            return pname === item.Pname;
          });

          data.splice(index, 1);

          let ProductsIndex = this.Products.findIndex((item) => {
            return productId === item.ProductId;
          });

          if (item.T === 2) {
            this.Products[ProductsIndex].T = 2;
            this.ProcessModels[ProcessModelsIndex].Processes.forEach((item) => {
              item.T = 1;
            });
            this.DetailModels[DetailModelsIndex].DetailModels.forEach(
              (item) => {
                item.T = 2;
              }
            );

            this.deleteProducts.push(this.Products[ProductsIndex]);
            this.deleteProcessModels.push(
              this.ProcessModels[ProcessModelsIndex]
            );
            this.deleteDetailModels.push(
              ...this.DetailModels[DetailModelsIndex].DetailModels
            );
          }

          this.DetailModels.splice(DetailModelsIndex, 1);
          this.ProcessModels.splice(ProcessModelsIndex, 1);
          this.Products.splice(ProductsIndex, 1);

          ids = this.Products.map((item) => {
            return item.ProductId;
          });

          ProcessModelsNames = this.ProcessModels.map((item) => {
            return item.Pname;
          });

          DetailModelsName = this.DetailModels.map((item) => {
            return item.Pname;
          });
        }
      });

      // 过滤出非添加的数据
      let newData = data.filter((item) => {
        return item.add == null;
      });

      console.log("newData---", newData);

      console.log("this.ProcessModels", this.ProcessModels);
      // 匹配存在的数据
      newData.forEach((item, i) => {
        item.OrderProductNo = this.OrderProductNo;
        let index = ids.indexOf(item.lastProductId);

        if (index !== -1) {
          this.$set(item, "TebomId", this.Products[index].TebomId);
          this.$set(
            item,
            "TespecialBomId",
            this.Products[index].TespecialBomId
          );
          this.$set(item, "ProgrammeId", this.Products[index].ProgrammeId);

          let tType = item.T == null ? this.Products[index].T : item.T;
          this.$set(item, "T", tType);
          this.$set(item, "WorkDocId", this.Products[index].WorkDocId);
          this.$set(
            item,
            "WorkDocProductId",
            this.Products[index].WorkDocProductId
          );
          this.$set(item, "WorkDocNo", this.Products[index].WorkDocNo);
          this.$set(item, "StockQuantity", this.Products[index].StockQuantity);
          this.$set(item, "ExistQuantity", this.Products[index].ExistQuantity);
          this.$set(
            item,
            "SchedulingType",
            this.Products[index].SchedulingType
          );
          this.$set(item, "DpId", this.Products[index].DpId);
          this.$set(item, "MaintenanceId", this.Products[index].MaintenanceId);
          this.$set(
            item,
            "ProductionType",
            this.Products[index].ProductionType
          );
          this.$set(
            item,
            "ProductionDpId",
            this.Products[index].ProductionDpId
          );
          this.$set(item, "DocDate", this.Products[index].DocDate);
          this.$set(item, "EndTime", this.Products[index].EndTime);
          this.$set(item, "Remark", this.Products[index].Remark);

          console.log("item.lastProductId", item.lastProductId);

          let ProcessModelsNameIndex = ProcessModelsNames.indexOf(
            item.lastProductId
          );
          let DetailModelsNamIndex = DetailModelsName.indexOf(
            item.lastProductId
          );

          console.log("ProcessModelsNameIndex", ProcessModelsNameIndex);

          let o = {
            Pno: item.Pno,
            Pname: item.Pname,
            ProductId: item.currentProductId,
            ProgrammeName:
              this.ProcessModels[ProcessModelsNameIndex].ProgrammeName,
            ProgrammeId: this.ProcessModels[ProcessModelsNameIndex].ProgrammeId,
            Processes: this.ProcessModels[ProcessModelsNameIndex].Processes,
          };

          _ProcessModels.push(o);

          let o1 = {
            Pname: item.Pname,
            ProductId: item.currentProductId,
            DetailModels: this.DetailModels[DetailModelsNamIndex].DetailModels,
          };

          _DetailModels.push(o1);
        } else {
          this.ProcessModels[i].Pname = item.Pname;
          this.ProcessModels[i].Pno = item.Pno;
          this.ProcessModels[i].Processes = [];
          this.ProcessModels[i].ProgrammeName = "";

          this.DetailModels[i].Pname = item.Pname;
          this.DetailModels[i].Pno = item.Pno;
          this.DetailModels[i].DetailModels = [];
        }
      });

      let addData = data.filter((item) => {
        return item.add;
      });

      addData.forEach((item, i) => {
        if (item.add) {
          this.$set(item, "T", 0);
          this.$set(item, "WorkDocId", 0);
          this.$set(item, "WorkDocProductId", 0);
          this.$set(item, "WorkDocNo", "");
          this.$set(item, "StockQuantity", 0);
          this.$set(item, "ExistQuantity", 0);
          this.$set(item, "SchedulingType", null);
          this.$set(item, "DpId", null);
          this.$set(item, "MaintenanceId", null);
          this.$set(item, "ProductionType", item.ProductNature);
          this.$set(item, "ProductionDpId", item.DefaultSupplier);
          this.$set(item, "DocDate", this.$commonJs.getToday());
          this.$set(item, "EndTime", "");
          this.$set(item, "Remark", "");

          this.$set(item, "TeProductDetailId", 0);
          this.$set(item, "TebomId", 0);
          this.$set(item, "TespecialBomId", 0);
          this.$set(item, "ProgrammeId", 0);

          _ProcessModels.push({
            Pno: item.Pno,
            Pname: item.Pname,
            ProductId: item.currentProductId,
            ProgrammeName: "",
            ProgrammeId: 0,
            Processes: [],
          });

          _DetailModels.push({
            Pname: item.Pname,
            ProductId: item.currentProductId,
            DetailModels: [],
          });

          item.OrderProductNo = this.OrderProductNo;
        }
      });

      newData.push(...addData);

      this.Products = newData;
      this.ProcessModels = _ProcessModels;
      this.Products.forEach((item, i) => {
        let qua = item.qua;
        _DetailModels[i].DetailModels.forEach((v) => {
          v.qua = qua / v.rateQua;
        });
      });
      this.DetailModels = _DetailModels;
    },
    /** 批量操作 */
    handleSelectionChange(val) {
      this.selList = val;
    },
    /** 批量-单据日期 */
    onDocDate(){
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId);
        if (duplicateObj) {
          obj1.DocDate = this.batchDocDate;
        }
        return obj1;
      });
      this.batchDocDate = ''
    },
    /** 批量-单据日期 */
    onDocEndTime(){
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId);
        if (duplicateObj) {
          obj1.EndTime = this.batchEndTime;
        }
        return obj1;
      });
      this.batchEndTime = ''
    }
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}

.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex2 {
  display: flex;
}
.mr8 {
  margin-right: 8px;
}
</style>
